import { render, staticRenderFns } from "./Publicar2.vue?vue&type=template&id=17c0dcbe&scoped=true"
import script from "./Publicar2.vue?vue&type=script&lang=js"
export * from "./Publicar2.vue?vue&type=script&lang=js"
import style0 from "./Publicar2.vue?vue&type=style&index=0&id=17c0dcbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c0dcbe",
  null
  
)

export default component.exports